module.exports = __webpack_public_path__ + "static/iosBannerMasterpass-b6146f743705b4e9b0f3930ee4e42a5d.jpg";